import React, { useState, useRef, useEffect } from 'react';

function ProfileDropdown({ userName, userRole, onLogout, onNavigateToProfile }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fallback if userName is not available
  const displayName = userName || 'User';

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getRoleColor = () => {
    switch (userRole) {
      case 'admin':
        return '#e74c3c';
      case 'facilitator':
        return '#3498db';
      case 'contributor':
        return '#27ae60';
      default:
        return '#95a5a6';
    }
  };

  const getRoleDisplay = () => {
    return userRole.charAt(0).toUpperCase() + userRole.slice(1);
  };

  return (
    <div className="profile-dropdown-wrapper" ref={dropdownRef}>
      <button
        className="profile-dropdown-btn"
        onClick={() => setIsOpen(!isOpen)}
        title={`${displayName} • ${getRoleDisplay()}`}
      >
        <span className="profile-avatar">{displayName.charAt(0)}</span>
        <span className="profile-name">{displayName}</span>
        <span className="dropdown-arrow">▼</span>
      </button>

      {isOpen && (
        <div className="profile-menu">
          <div className="profile-header">
            <div className="profile-avatar-large">{displayName.charAt(0)}</div>
            <div className="profile-info">
              <div className="profile-name-large">{displayName}</div>
              <div className="profile-role" style={{ color: getRoleColor() }}>
                {getRoleDisplay()}
              </div>
            </div>
          </div>
          <div className="profile-divider"></div>
          <button className="profile-menu-item" onClick={() => {
            setIsOpen(false);
            onNavigateToProfile?.();
          }}>
            👤 Profile
          </button>
          <button className="profile-menu-item" disabled>
            ⚙️ Settings (Coming Soon)
          </button>
          <div className="profile-divider"></div>
          <button className="profile-menu-item logout" onClick={onLogout}>
            🚪 Logout
          </button>
        </div>
      )}

      <style>{`
        .profile-dropdown-wrapper {
          position: relative;
        }

        .profile-dropdown-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: #f8f9fa;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          color: #2c3e50;
          transition: all 0.2s ease;
        }

        .profile-dropdown-btn:hover {
          background: #e8e9ea;
          border-color: #8FC5B2;
        }

        .profile-avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background: #8FC5B2;
          color: white;
          border-radius: 50%;
          font-weight: 600;
          font-size: 14px;
        }

        .profile-name {
          font-weight: 500;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .dropdown-arrow {
          font-size: 11px;
          color: #95a5a6;
          transition: transform 0.2s ease;
        }

        .profile-dropdown-btn:active .dropdown-arrow {
          transform: rotateZ(180deg);
        }

        .profile-menu {
          position: absolute;
          top: 100%;
          right: 0;
          margin-top: 8px;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          min-width: 220px;
          z-index: 1000;
          overflow: hidden;
        }

        .profile-header {
          display: flex;
          gap: 12px;
          padding: 16px;
          background: #f9f9f9;
        }

        .profile-avatar-large {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #8FC5B2;
          color: white;
          border-radius: 50%;
          font-weight: 600;
          font-size: 16px;
          flex-shrink: 0;
        }

        .profile-info {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .profile-name-large {
          font-weight: 600;
          color: #2c3e50;
          font-size: 14px;
        }

        .profile-role {
          font-size: 12px;
          font-weight: 500;
        }

        .profile-divider {
          height: 1px;
          background: #e0e0e0;
        }

        .profile-menu-item {
          width: 100%;
          padding: 12px 16px;
          background: none;
          border: none;
          text-align: left;
          cursor: pointer;
          font-size: 14px;
          color: #2c3e50;
          transition: background 0.2s ease;
        }

        .profile-menu-item:hover:not(:disabled) {
          background: #f9f9f9;
        }

        .profile-menu-item:disabled {
          color: #bdc3c7;
          cursor: not-allowed;
        }

        .profile-menu-item.logout {
          color: #e74c3c;
          font-weight: 500;
        }

        .profile-menu-item.logout:hover {
          background: #fadbd8;
        }
      `}</style>
    </div>
  );
}

export default ProfileDropdown;
